import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ProfileUserMenu from "./ProfileUserMenu";
import CartButton from "../../../../components/ui/elements/CartButton";
import FavoriteButton from "../../../../components/ui/elements/FavoriteButton";
import { getCartItemsCount } from "../../../../utils/storage";
import { getFavoritesCount } from "../../../../utils/favorites";

interface MobileHeaderProps {
  onCartClick: () => void;
  onFavoritesClick: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onCartClick, onFavoritesClick }) => {
  const [cartItemCount, setCartItemCount] = useState(0);
  const [favoriteCount, setFavoriteCount] = useState(0);

  const refreshCartCount = () => setCartItemCount(getCartItemsCount());
  const refreshFavoritesCount = () => setFavoriteCount(getFavoritesCount());

  useEffect(() => {
    refreshCartCount();
    refreshFavoritesCount();
    window.addEventListener('cartUpdated', refreshCartCount);
    window.addEventListener('favoritesUpdated', refreshFavoritesCount);
    return () => {
      window.removeEventListener('cartUpdated', refreshCartCount);
      window.removeEventListener('favoritesUpdated', refreshFavoritesCount);
    };
  }, []);

  return (
    <div className="flex items-center justify-between w-full md:hidden">
      <Link
        to="/"
        className="flex items-center transition-opacity duration-200 hover:opacity-80"
      >
        <img
          src="/assets/logo/LogoBrainCreaWhite.png"
          alt="Braincrea"
          className="h-16"
        />
      </Link>

      <div className="flex items-center gap-2">
        <CartButton cartItemCount={cartItemCount} onClick={onCartClick} />
        <FavoriteButton favoriteCount={favoriteCount} onClick={onFavoritesClick} />
        <ProfileUserMenu />
      </div>
    </div>
  );
};

export default MobileHeader;